// getProfileTdk.js
'use strict';

import { ProfileListType } from '../resource/profileConstants.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

/**
 * Get profile tdk
 * @param {string} username - username.
 * @param {string} biography - user's biography.
 * @param {string} listType - ex: ProfileListType.FLIX
 * @param {function} t - i18n.t
 */
const getProfileTdk = ({ username, biography, listType, t }) => {
  let displayTitle;
  let displayDescription;
  const displayKeywords = t('seo_cp_keywords', {
    cp_name: username,
    ns: TranslationNamespace.SEO,
  });

  switch (listType) {
    case ProfileListType.FLIX: {
      displayTitle = t('seo_cp_profile_video_title', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('title_flix', {
          ns: TranslationNamespace.PROFILE,
        }),
        ns: TranslationNamespace.SEO,
      });
      displayDescription = t('seo_cp_profile_video_description', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('title_flix', {
          ns: TranslationNamespace.PROFILE,
        }),
        ns: TranslationNamespace.SEO,
      });
      break;
    }
    case ProfileListType.IMAGE: {
      displayTitle = t('seo_cp_profile_image_title', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('profile_photo', {
          ns: TranslationNamespace.PROFILE,
        }),
        ns: TranslationNamespace.SEO,
      });
      displayDescription = t('seo_cp_profile_image_description', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('profile_photo', {
          ns: TranslationNamespace.PROFILE,
        }),
        ns: TranslationNamespace.SEO,
      });
      break;
    }
    case ProfileListType.POST:
    case ProfileListType.STORY:
    case ProfileListType.HOME:
    default: {
      const pageType = t(
        ProfileListType.HOME === listType
          ? 'home_page'
          : ProfileListType.POST === listType
            ? 'post_title'
            : 'broadcast',
        {
          ns: TranslationNamespace.PROFILE,
        }
      );
      displayTitle = t('seo_cp_title', {
        cp_name: username,
        cp_profile: biography,
        page_type: pageType,
        ns: TranslationNamespace.SEO,
      });
      displayDescription = t('seo_cp_description', {
        cp_name: username,
        cp_profile: biography,
        page_type: pageType,
        ns: TranslationNamespace.SEO,
      });
      break;
    }
  }

  return { displayTitle, displayDescription, displayKeywords };
};

export default getProfileTdk;
